import './bootstrap';
import '../scss/app.scss';

import.meta.glob([
//     '../images/**',
    '../fonts/**'
]);

import {createApp, h} from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from '../../vendor/tightenco/ziggy';
import Layout from "@/Layouts/Layout.vue";
import {i18nVue} from "laravel-vue-i18n";

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    id: 'app',
    title: (title) => `${title} - ${appName}`,
    resolve: async (name) => {
        const page = await resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'));
        page.default.layout = page.default.layout || Layout;
        return page;
    },
    setup({el, App, props, plugin}) {
        const vueApp = createApp({render: () => h(App, props)})

        vueApp.use(plugin).use(ZiggyVue).use(i18nVue, {
            fallbackLang: "fr",
            resolve: async (lang) => {
                const langs = import.meta.glob("../../lang/*.json");
                return await langs[`../../lang/${lang}.json`]();
            },
        });

        vueApp.mount(el);
        return vueApp;
    },
    progress: {
        color: '#2D40F9',
    },
});

